import Alertify from "alertify.js";
// import scriptjs from 'scriptjs'
import dateFormat from "dateformat";
import Cookies from "js-cookie";
const utils = {
  vm: null,
  authInit(vm) {
    this.vm = vm;
    return new Promise((resolve, reject) => {
      const token = Cookies.get("token");
      if (token) {
        // const permission =JSON.parse(Cookies.get('permission'));
        // vm.$store.commit('TOKEN_INIT', { 'token': token});
        // vm.$store.dispatch('fetchProjectList');
        // vm.$store.dispatch("fetchCityList");
      }
      resolve();
    });
  },
  initEndTime: function (time) {
    //结束时间修改为当前时间23：59：59DELETEDELETE
    if (time) return time + 24 * 60 * 60 * 1000 - 1000;
  },
  loginRedirect(cb, redirect = true) {
    if (this.$store.state.auth.token !== "") {
      cb();
    } else {
      const str = redirect ? "?returnUrl=" + this.$route.path : "";
      this.$router.push("/login" + str);
    }
  },
  setCookie(key, value) {
    Cookies.set(key, value);
  },
  getCookie(name) {
    return Cookies.get(name);
  },
  autoSizeImage(w, h, slim = false) {
    // return `?imageMogr2/thumbnail/${w}x${h}/blur/1x0/quality/100${slim ? '|imageslim': ''}`
    return `?imageMogr2/auto-orient/thumbnail/!${w}x${h}r/gravity/Center/crop/${w}x${h}/blur/1x0/quality/100${
      slim ? "|imageslim" : ""
    }`;
  },
  avatar(url, w, h) {
    return url + utils.autoSizeImage(w, h);
  },
  scrollTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  alert: function () {
    Alertify.alert(...arguments);
  },

  log: function () {
    Alertify.log(...arguments);
  },

  confirm: function () {
    Alertify.confirm(...arguments);
  },
  // myConfirm: function () {
  //   Alertify.confirm(...arguments).set({labels:{ok:'', cancel:'取消'}, padding: false});
  // },
  error: function () {
    Alertify.error(...arguments);
  },
  // //定义一个加法函数
  // 'add': function (num1, num2) {
  //   var baseNum, baseNum1, baseNum2;
  //   var precision;// 精度
  //   try {
  //     baseNum1 = num1.toString().split(".")[1].length;
  //   } catch (e) {
  //     baseNum1 = 0;
  //   }
  //   try {
  //     baseNum2 = num2.toString().split(".")[1].length;
  //   } catch (e) {
  //     baseNum2 = 0;
  //   }
  //   // //console.log('1是'+baseNum1);
  //   // //console.log('2是'+baseNum2);
  //   baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  //   precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
  //   return ((num1 * baseNum + num2 * baseNum) / baseNum).toFixed(precision);
  // },
  checkResponse: function (res, showError = true) {
    if (0 === res.data.code || 200 === res.data.code) {
      return res.data;
    } else if (103000 === res.data.code) {
      //未登录 或者登录超时
      // 清空本地token跳转到登录页面
      // window.open('/auth/login');
      console.log("走的这里2");
      console.log(window.location);
      var arr = window.location.href.split("?");
      if (arr[1]) {
        this.vm.$router.push("/auth/login?" + arr[1]);
      } else {
        this.vm.$router.push("/auth/login");
      }
      localStorage.clear();
      this.vm.$store.commit("changeCommand", "");
      Cookies.remove("token");
      return false;
    } else {
      this.vm.$message.error(res.data.msg);
      return false;
    }
  },
  retrieve_err_msg: function (data) {
    if (
      "object" === typeof data &&
      "string" === typeof data.err_msg &&
      data.err_msg.length > 0
    ) {
      return data.err_msg;
    }
  },
  formatDate: function (date) {
    return dateFormat(date, "yyyy-mm-dd");
  },
  formatDateToSecond: function (date) {
    if (date) {
      var time = dateFormat(date, "yyyy-mm-dd  HH:MM:ss");
      return time;
    } else {
      return;
    }
  },
  form: function (date) {
    if (date) {
      return new Date(date).getTime();
    } else {
      return;
    }
  },
  delRepeat: function (arr) {
    var obj = {};
    arr = arr.reduce((cur, next) => {
      obj[next.orderNo] ? "" : (obj[next.orderNo] = true && cur.push(next));
      return cur;
    }, []);
    return arr;
  },
  //除法精度
  accDiv: function (arg1, arg2) {
    var t1 = 0,
      t2 = 0,
      r1,
      r2;
    try {
      t1 = arg1.toString().split(".")[1].length;
    } catch (e) {}
    try {
      t2 = arg2.toString().split(".")[1].length;
    } catch (e) {}
    r1 = Number(arg1.toString().replace(".", ""));
    r2 = Number(arg2.toString().replace(".", ""));
    return (r1 / r2) * Math.pow(10, t2 - t1);
  },
  //乘法精度
  mul: function (arg1, arg2) {
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length;
    } catch (e) {}
    try {
      m += s2.split(".")[1].length;
    } catch (e) {}
    return (
      (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
      Math.pow(10, m)
    );
  },
  //加法精度
  add: function (num1, num2) {
    var baseNum, baseNum1, baseNum2;
    var precision; // 精度
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    // //console.log('1是'+baseNum1);
    // //console.log('2是'+baseNum2);
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2;
    return ((num1 * baseNum + num2 * baseNum) / baseNum).toFixed(precision);
  },
  //减法精度
  numSub: function (num1, num2) {
    var baseNum, baseNum1, baseNum2;
    var precision; // 精度
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2;
    return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
  },
  timeChangeformat: function (time) {
    console.log("time", time);
    if (time) {
      let time1 = time.split(" ");
      var str1 = time1[0];
      var str2 = time1[1];
      var leftSplit = str1.split("-");
      var rightSplit = str2.split(":");
      var year = leftSplit[0];
      var month = leftSplit[1];
      var day = leftSplit[2];
      var hour = rightSplit[0];
      var minute = rightSplit[1];
      var second = rightSplit[2];
      return `${year}年${month}月${day}日${hour}时${minute}分${second}秒`;
    }
  },
  FunGetDateStr: function (p_count) {
    var dd = new Date();
    dd.setDate(dd.getDate() + p_count); //获取p_count天后的日期
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1; //获取当前月份的日期
    if (m < 10) {
      m = "0" + m;
    }
    var d = dd.getDate();
    if (d < 10) {
      d = "0" + d;
    }
    return y + "-" + m + "-" + d + " " + "00:00:00";
  },
  timestampToTime: function (timestamp) {
    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    var s =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
  },
};

export default utils;



// WEBPACK FOOTER //
// ./src/utils.js